import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import classes from './UnsavedChanges.module.scss'

const UnsavedChanges = ({ className, onDiscardClick, ...props }) => {
  let compClassName = classes.unsavedChanges
  if (className) compClassName += ' ' + className

  return (
    <span className={compClassName}>
      <span
        className={'c-orange ' + classes.unsavedChangesInfo}>
        <FormattedMessage id='UNSAVED_CHANGES_INFO' />
      </span>
      <a
        href='#'
        onClick={onDiscardClick}>
        <FormattedMessage id='UNSAVED_CHANGES_DISCARD' />
      </a>
    </span>
  )
}

UnsavedChanges.propTypes = {
  className: PropTypes.string,
  onDiscardClick: PropTypes.func
}

export default UnsavedChanges
